import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Redirect, Switch } from "react-router-dom";

import "./bryntum-lib/columns/RegisterColumns.jsx";
import "./bryntum-lib/widget/fields/RegisterFields.jsx";
import "./bryntum-lib/plugins/PluginsBryntumClasses.jsx";
import "./bryntum-lib/overrides/OverriddenBryntumClasses.jsx";
import "./bryntum-lib/widget/extendingClasses/RegisterWidgetOverridden.jsx";

import Loader from "./react/components/loader/Loader";
import AdminRoutes from "./react/routes/AdminRoutes.jsx";
import ReactToast from "./react/components/ReactToast.jsx";
import ErrorBoundary from "./react/components/error/ErrorBoundary";
import { AuthContextProvider } from "./react/context/authContext.jsx";
import { ThemeProvider } from "./modern/contexts/ThemeContext";

import "./index.css";
import 'intl-tel-input/build/js/utils';
import "react-toastify/dist/ReactToastify.css";
import "intl-tel-input/build/css/intlTelInput.css"
import "./sentryIntegration.jsx";
import "./logRocketIntegration.jsx";
import "./googlePlacesIntegration.jsx"
import { ConfirmDialogProvider } from "@omit/react-confirm-dialog";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./lib/queryClient";

ReactDOM.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
    <Router>
      <ThemeProvider>
        <AuthContextProvider>
          <div className="min-h-screen AppView">
            <Loader />
            <ConfirmDialogProvider
              defaultOptions={{
                // Above File Detail (+10), promote/nested (+20), and menus (+30).
                alertDialogContent: {
                  className: "z-[calc(var(--swivu-bryntum-z-index)+40)]",
                },
                alertDialogOverlay: {
                  className: "z-[calc(var(--swivu-bryntum-z-index)+40)]",
                },
              }}
            >
              <Switch>
                <Redirect from="/invite" exact to={{ pathname: "/", search: window.location.search }} />
                <AdminRoutes />
              </Switch>
            </ConfirmDialogProvider>
            <ReactToast />
          </div>
        </AuthContextProvider>
      </ThemeProvider>
    </Router>
    {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </ErrorBoundary>,
  document.getElementById("root")
);
